




































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { DepositLog, DepositLogJson } from '@/models/filebunker/depositlog';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { Utils } from '@/helper/utils';
import { paymentService, depositLogService, laneService } from '@/shared';
import { mask } from 'vue-the-mask';
import { RoleType } from '@/helper/enum';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  props: ['methodName', 'progress'],
  directives: {
    mask,
  },
  computed: {
    isValidate() {
      return this.paymentProvider == 'Cenpos'
        ? this.selectedPaymentType &&
        this.amount &&
        this.amount !== '0.00' &&
        this.amount > 0 &&
        this.firstName &&
        this.lastName &&
        this.phoneNumber &&
        this.email &&
        this.zipCode &&
        this.city &&
        this.state &&
        this.address
        : this.addCustomerToDms == true
          ? this.selectedPaymentType &&
          this.amount &&
          this.amount !== '0.00' &&
          this.amount > 0 &&
          this.firstName &&
          this.lastName &&
          this.phoneNumber &&
          this.email &&
          this.zipCode &&
          this.city &&
          this.state &&
          this.address
          : this.selectedPaymentType &&
          this.amount &&
          this.amount !== '0.00' &&
          this.amount > 0 &&
          this.firstName &&
          this.lastName;
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue'),
  },
})
class AddDepositLogPage extends Base {
  public errors!: any;
  public depositLog: DepositLog = {};
  public paymentDialog: boolean = false;
  public depositLogJson: any = {};
  public dialogTitle: string = '';
  public loading: boolean = false;
  public depositLogNumberValue: boolean = false;
  public validateDLNumber: boolean = false;
  public addCustomerToDms: boolean = false;
  public isOverrideCCFeeApplied: boolean = true;
  public bypassReason: string = "";
  public depositLogNumber: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public phoneNumber: string = '';
  public comments: string = '';
  public amount: string = '';
  public email: string = '';
  public zipCode: string = '';
  public city: string = '';
  public state: string = '';
  public address: string = '';
  public customerCode: string = '';
  public isSendPaymentReceipt: boolean = true;
  public isCloverDialog: boolean = false;
  public isCloverConfigured: boolean = false;
  public IsBypassCreditFeeRole: boolean = false;
  public selectedPaymentType: string = '';
  public contactAt: string = '';
  public lanes: any = [];
  public lane: string = '';
  public requestProgress: boolean = false;
  public isLaneLoading: boolean = false;
  public isShowBypassReasonField: boolean = false;
  public cenposDialog: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public cenposUrl: string = Utils.WEB_BASE_URL + '/serverpay/cenpos';
  public storeId: number = 0;
  public paymentProvider: string = '';
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeName: string = '';
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public depositLogId: number = 0;
  public isCenposConfigured: boolean = false;
  public isSquareConfigured: boolean = false;
  public paymentProviderLoader: boolean = false;
  public squareDialog: boolean = false;

  public isShowWarning: boolean = false;
  public warningMessage = '';
  public isTerminalPaymentEnabled: boolean = false;

  // Dialog
  public customerInfoDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('depositLogAdd.customerInfoDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t(
        'depositLogAdd.customerInfoDialog.lblSend'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.sendPaymentLink();
    },
  };
  public laneDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('depositLogAdd.laneDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-money-bill',
      text: this.$parent.$t('depositLogAdd.laneDialog.lblPay') as string,
      disable: false,
    },
    onAction: (): void => {
      this.vantivTerminalPay();
    },
    onClose: (): void => {
      this.moveBack();
    }
  };

  public moveBack() {
    this.$router.push({ name: 'app.depositlogs' });
  }

  public confirmDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('depositLogAdd.confirmDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('depositLogAdd.confirmDialog.lblAgree') as string,
    },
    onAction: (): void => {
      this.payManually();
    },
  };
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    if (methodName === 'submit') {
      if (
        this.selectedPaymentType &&
        this.amount &&
        this.amount !== '0.00' &&
        Number(this.amount) > 0 &&
        this.firstName &&
        this.lastName &&
        this.phoneNumber
      ) {
        this.submit();
      } else {
        this.showAlert(false, this.$t('depositLogAdd.alertFormNotValid'));
        this.$emit('resetMethodName', methodName);
        return;
      }
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateCenposDialog(cenposDialogVaue) {
    this.cenposDialog = cenposDialogVaue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public validatedepositLogNo(value) {
    // tslint:disable-next-line:max-line-length
    const re = /^[a-zA-Z0-9]+$/;
    const data = re.test(value);
    if (data) {
      this.validateDLNumber = true;
    } else {
      this.validateDLNumber = false;
    }
    return data;
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('depositLogAdd.btnBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('depositLogAdd.btnBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.$watch('firstName', (newVal) => {
      this.paymentOptions.firstName = newVal;
    });

    this.$watch('lastName', (newVal) => {
      this.paymentOptions.lastName = newVal;
    });

    this.$watch('phoneNumber', (newVal) => {
      this.paymentOptions.phoneNumber = newVal;
    });
    this.$watch('comments', (newVal) => {
      this.paymentOptions.comments = newVal;
    });
    this.$watch('city', (newVal) => {
      this.paymentOptions.city = newVal;
    });
    this.$watch('address', (newVal) => {
      this.paymentOptions.address = newVal;
    });
    this.$watch('state', (newVal) => {
      this.paymentOptions.state = newVal;
    });
    this.$watch('amount', (newVal) => {
      this.paymentOptions.amount = newVal;
    });
    this.$watch('zipcode', (newVal) => {
      this.paymentOptions.zipcode = newVal;
    });
    this.$watch('email', (newVal) => {
      this.paymentOptions.customerEmail = newVal;
    });
    this.$watch('depositLogId', (newVal) => {
      this.paymentOptions.recordKey = newVal;
    });
    this.$watch('depositLogNumber', (newVal) => {
      this.paymentOptions.invoiceNumber = newVal;
    });
    this.$watch('isSendPaymentReceipt', (newVal) => {
      this.paymentOptions.isSendPaymentReceipt = newVal;
    });
    this.$watch('isOverrideCCFeeApplied', (newVal) => {
      this.paymentOptions.isOverrideCCFeeApplied = newVal;
    });
    this.$watch('bypassReason', (newVal) => {
      this.paymentOptions.bypassReason = newVal;
    });

    const depositId = Number(this.$route.query.depositId);
    this.depositLogId = this.$route.query.depositId
      ? Number(this.$route.query.depositId)
      : 0;

    if (depositId) {
      this.dialogTitle = this.$t('depositLogAdd.editTitle') as string;
      this.getDeposit(depositId);
    } else {
      this.dialogTitle = this.$t('depositLogAdd.addTitle') as string;
    }

    this.getDefaultPaymentType();
    this.currentUrl = window.location.href;

    var role = [RoleType.BypassCreditCardFee.toString()];
    var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
    this.IsBypassCreditFeeRole = isRoleAllowed.includes(role[0]);


  }
  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.depositlogs' });
    }
  }

  public showBypassReasonField(value: boolean) {
    if (!value) {
      this.isShowBypassReasonField = true;
    } else {
      this.isShowBypassReasonField = false;
      this.bypassReason = '';
      this.depositLogJson.bypassReason = '';
    }
  }

  public async getDeposit(id: number): Promise<void> {
    try {
      this.loading = true;
      const depositLog = await depositLogService.getDepositLogAsync(id);
      this.depositLog = depositLog;
      this.firstName = this.depositLog.depositLogJson.firstName;
      this.lastName = this.depositLog.depositLogJson.lastName;
      this.phoneNumber = this.depositLog.depositLogJson.phoneNumber;
      this.comments = this.depositLog.depositLogJson.comments;
      this.amount = this.depositLog.depositLogJson.amount;
      this.phoneNumber = this.depositLog.depositLogJson.phoneNumber;
      this.comments = this.depositLog.depositLogJson.comments;
      this.email = this.depositLog.depositLogJson.email;
      this.zipCode = this.depositLog.depositLogJson.zipCode;
      this.loading = false;
    } catch (e) {
      this.showAlert(true, this.$t('depositLogAdd.alertErrorOccurred'));
    } finally {
      this.loading = false;
    }
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      this.paymentProviderLoader = true;
      const result = await depositLogService.getDefaultPaymentProvider(
        this.userSession.storeId
      );

      this.isTerminalPaymentEnabled = result.isTerminalPaymentEnabled;
      this.paymentProvider = result.paymentProvider;
      this.storeId = result.storeId;
      this.tenantId = result.tenantId;
      this.enterpriseId = result.enterpriseId;
      this.storeName = result.storeName;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;
      this.isCenposConfigured = result.isCenposConfigured;
      this.isSquareConfigured = result.isSquareConfigured;
      this.isCloverConfigured = result.isCloverConfigured;
    } finally {
      this.paymentProviderLoader = false;
    }
  }

  public async submit(): Promise<void> {
    if (await this.validateForm()) {
      if (!this.selectedPaymentType) {
        this.showAlert(false, 'Please select payment type');
        return;
      }


      try {
        if (this.depositLogNumberValue) {
          if (this.depositLogNumber.length > 9) {
            this.showAlert(false, 'Deposit log number exceeds max length');
            return;
          }
          if (!this.validateDLNumber) {
            this.showAlert(false, 'Invalid Deposit log number');
            return;
          }
        }

        if (this.state.length > 2) {
          this.showAlert(false, 'State exceeds max length');
          return;
        }

        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        this.depositLogJson.firstName = this.firstName;
        this.depositLogJson.lastName = this.lastName;
        this.depositLogJson.phoneNumber = this.phoneNumber;
        this.depositLogJson.comments = this.comments;
        this.depositLogJson.amount = Number(this.amount).toFixed(2);
        this.depositLogJson.email = this.email;
        this.depositLogJson.zipCode = this.zipCode;
        this.depositLogJson.city = this.city;
        this.depositLogJson.state = this.state;
        this.depositLogJson.address = this.address;
        this.depositLogJson.depositNumber = this.depositLogNumber;
        this.depositLogJson.isSendPaymentReceipt = this.isSendPaymentReceipt;
        this.depositLogJson.isOverrideCCFeeApplied = this.isOverrideCCFeeApplied;
        this.depositLogJson.bypassReason = this.bypassReason;

        let result;
        if (this.addCustomerToDms) {
          result = await this.addcustomer();
        }
        const res = result ? result : true;
        if (res) {
          if (Number(this.amount) > 0 && this.amount) {
            switch (this.selectedPaymentType) {
              case 'rdVantiv':
                this.findLanes();
                break;
              case 'rdText':
                this.contactAt = '';
                this.contactAt = this.phoneNumber;
                this.customerInfoDialog.model = true;
                break;
              case 'rdManual':
                if (this.paymentProvider == 'Vantiv') {
                  this.confirmDialog.model = true;
                } else {
                  this.paymentDialog = true;
                  this.$root.$emit('validatePaymentProvider');
                }
                break;
              default:
            }
          } else {
            this.showAlert(false, this.$t('depositLogAdd.alertAmountEmpty'));
          }
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }

  public async sendPaymentLink(): Promise<void> {
    if (!this.contactAt || this.contactAt === '0') {
      this.showAlert(false, this.$t('depositLogAdd.alertReuiredField'));
      return;
    }
    try {
      this.customerInfoDialog.loading = true;
      await depositLogService.sendPaymentLinkAsync(
        this.contactAt,
        this.depositLogJson,
        this.isOverrideCCFeeApplied,
        this.bypassReason
      );
      this.showAlert(true, this.$t('depositLogAdd.alertTextSent'));
      this.$router.push({ name: 'app.depositlogs' });
    } finally {
      this.customerInfoDialog.loading = false;
      this.customerInfoDialog.model = false;
    }
  }

  public async payManually(): Promise<void> {
    try {
      this.confirmDialog.loading = true;
      const depositLog = await paymentService.depositLogPayManually(
        this.depositLogJson
      );
      window.location.href = depositLog.paymentUrl;
    } finally {
      this.confirmDialog.loading = false;
      this.confirmDialog.model = false;
    }
  }

  public async addcustomer(): Promise<boolean> {
    try {
      const response = await depositLogService.addCustomer(this.depositLogJson);
      if (response.status == true) {
        this.showAlert(true, response.message);
      } else {
        this.showAlert(false, response.message);
      }
      return response.status;
    } finally {
      // finally block
    }
  }

  public async findLanes(): Promise<void> {
    try {
      this.warningMessage = '';
      this.isShowWarning = false;
      this.laneDialog.action.disable = false;
      this.loading = true;
      this.getLanes();
    } finally {
      this.loading = false;
    }
  }

  public async getLanes(): Promise<void> {
    try {
      this.isLaneLoading = true;
      this.laneDialog.model = true;
      const lanes = await laneService.getLanesAsync();
      this.lane = '';
      this.lanes = lanes.results;
    } finally {
      this.isLaneLoading = false;
    }
  }

  public async vantivTerminalPay(): Promise<void> {
    if (!this.lane) {
      this.showAlert(false, this.$t('depositLogAdd.alertSelectLane'));
      return;
    }
    try {
      this.laneDialog.loading = true;
      var response = await paymentService.depositLogTerminalPay(
        this.lane,
        this.depositLogJson
      );
      var isInProcess = false;
      var isFailed = false;
      var isApproved = false;
      //For Payroc payments, the payment status is updated via a web job, so there's no need to check the payment status repeatedly
      if (this.paymentProvider != 'Payroc') {
        for (var i = 0; i <= 3; i++) {
          await new Promise((resolve) => setTimeout(resolve, 15000)); // 3 sec
          const paymentResponse = await paymentService.getPaymentDetailStatus(
            response.transactionHeaderId,
            response.transactionDetailId
          );

          if (paymentResponse.status == 'Approved') {
            isApproved = true;
            break;
          }
        }
      }
      else {
        const paymentResponse = await paymentService.getPaymentDetailStatus(
          response.transactionHeaderId,
          response.transactionDetailId
        );
        if (paymentResponse.status == 'InProcess') {
          isInProcess = true;
        }
        else if (paymentResponse.status == 'Failed') {
          isFailed = true;
        }
      }
      this.isShowWarning = true;

      if (isFailed) {
        this.laneDialog.model = false;
        this.moveBack();
        this.showAlert(false, "Payment Failed. Please Try Again");
      }
      else if (isInProcess) {
        this.warningMessage = "Payment Created Successfully, Please check the payment final status in Payment report.";
      }
      else if (isApproved) {
        this.warningMessage = "Payment is Approved Successfully.";
        this.showAlert(true, "Payment is Approved Successfully.");
      }
      else {
        //this.showAlert(true, response.responseMessage);
        this.warningMessage = "Approving Payment callback taking a longer time, Please check the payment final status in Payment report.";
      }

      this.laneDialog.action.disable = true;
    } finally {
      this.laneDialog.loading = false;
      //this.laneDialog.model = false;
    }
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public paymentOptions: IPaymentDialog = {
    id: "depositLogPayment",
    url: window.location.href,
    firstName: this.firstName,
    lastName: this.lastName,
    phoneNumber: this.phoneNumber,
    comments: this.comments,
    city: this.city,
    address: this.address,
    state: this.state,
    amount: Number(this.amount),
    zipcode: this.zipCode,
    customerEmail: this.email,
    recordKey: this.depositLogId.toString(),
    recordIdentifier: "DepositLog",
    type: "0",
    invoiceNumber: this.depositLogNumber,
    isSendPaymentReceipt: this.isSendPaymentReceipt,
    isOverrideCCFeeApplied: this.isOverrideCCFeeApplied,
    bypassReason: this.bypassReason
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }
}
export default AddDepositLogPage;
